module.exports = __webpack_public_path__ + "static/media/teutonmager-webfont.a271b4ee.ttf";